import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useCreateChallenge = () => {
  const queryClient = useQueryClient();
  const local = process.env.REACT_APP_PROXY_PREFIX || '';
  
  return useMutation({
    mutationFn: async ({ file }) => {
      const formData = new FormData();
      formData.append('file', file);  
      
      const result = await restClient({
        url: `${local}/challenge-definitions`,  
        method: 'post',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'  
        }
      });
      return result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['resultsChallenges'] });
    },
    onError: (error) => {
      console.error('Error creating challenge:', error);
    }
  });
};
